import { useCallback } from "react";
import { useSelector } from "react-redux";
import { useNavigate, useSearchParams } from "react-router-dom-v5-compat";
import { PACKAGES_QUERY_PARAM } from "@b2bportal/core-packages";
import { getPackageRoutes } from "@b2bportal/core-utilities";
import {
  CarShopBookingSection,
  type CarShopBookingSectionType,
} from "@tenant/cars";
import { PackageBaseSelectors, PackageSearchSelectors } from "@/store";

export const PackageCarShopBookingSection = ({
  className,
  children,
  onClick,
  car,
  dayCount,
}: CarShopBookingSectionType) => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  const packageToken = useSelector(
    PackageBaseSelectors.getCurrentActivePackageToken
  );
  const packageType = useSelector(
    PackageBaseSelectors.getCurrentActivePackageType
  );
  const origin = useSelector(PackageSearchSelectors.getSearchFormOrigin);
  const destination = useSelector(
    PackageSearchSelectors.getSearchFormDestination
  );

  // we want to override the onClick to go to shop, otherwise use our override.
  const onNextHandler = useCallback(() => {
    const checkoutParams = new URLSearchParams(searchParams);
    checkoutParams.set(PACKAGES_QUERY_PARAM.packageType, packageType);
    checkoutParams.set(PACKAGES_QUERY_PARAM.packageToken, packageToken);
    if (origin) {
      checkoutParams.set(PACKAGES_QUERY_PARAM.origin, origin.code);
    }
    if (destination) {
      checkoutParams.set(PACKAGES_QUERY_PARAM.destination, destination.code);
    }
    // Cars is always last, head to checkout.
    navigate(
      `${getPackageRoutes().FULL_ROUTES.CHECKOUT}?${checkoutParams.toString()}`
    );
  }, [navigate, searchParams, packageToken, packageType, origin, destination]);

  return (
    <CarShopBookingSection
      className={className}
      children={children}
      onClick={onNextHandler}
      car={car}
      dayCount={dayCount}
    />
  );
};
